import Typo from '@/ui/typo/Typo';
import {
  Container,
  Wrapper,
  NameWrapper,
  DataWrapper,
  NameContainer,
  Data,
  Img,
  TextWrapper,
} from './ScoreStyles';
import Plus from '@/ui/icon/plus/Plus';
import Score2 from '@/ui/caption/score2/Score2';
import pulseImg from '@/assets/pulse.svg';
import vectorImg from '@/assets/vector.svg';
import exposureImg from '@/assets/exposure.svg';
import { COLORS } from '@/styles/colorTheme';

interface ScoreProps {
  type: string;
  companyName: string;
  score: string;
  scoreChange: string;
  onClick: () => void;
  onAdd: () => void;
  onCancel: () => void;
  isSelected: boolean;
}

const Score = ({
  type,
  companyName,
  score,
  scoreChange,
  onClick,
  onAdd,
  onCancel,
  isSelected,
}: ScoreProps) => {
  return (
    <Container>
      <Wrapper onClick={onClick}>
        <NameContainer>
          <NameWrapper>
            <div className="text-sm text-text-400 text-sm">{companyName}</div>
          </NameWrapper>
        </NameContainer>

        <DataWrapper className="space-x-2">
          <div className="flex items-center justify-end gap-1 w-[70px]">
            <div className="mr-auto">
              {type === 'pulse' ? <Img src={pulseImg} alt="pulse" /> : null}
              {type === 'exposure' ? <Img src={exposureImg} alt="exposure" /> : null}
              {type === 'vector' ? <Img src={vectorImg} alt="vector" /> : null}
            </div>
            <div className="text-sm text-text-300 text-sm">
              {score}
              {type === 'exposure' ? '%' : ''}
            </div>
          </div>
          <Score2 change={Number(scoreChange)} type={type} />
          <Plus onClick={isSelected ? onCancel : onAdd} isSelected={isSelected} />
        </DataWrapper>
      </Wrapper>
    </Container>
  );
};

export default Score;
